import React from "react"

interface EmailProps {
  email: string
}

const EmailWithBreak: React.FC<EmailProps> = ({ email }) => {
  const formattedEmail = email.replace(/@/g, "@<wbr>")

  return <span dangerouslySetInnerHTML={{ __html: formattedEmail }} />
}

export default EmailWithBreak
